import { yupResolver } from "@hookform/resolvers/yup";
import { useForm } from "react-hook-form";
import { string, object, ObjectSchema, ref, boolean, number } from "yup";

export type CreateAccountFormValues = {
  firstName: string;
  lastName: string;
  county: string;
  municipality: string;
  email: string;
  password: string;
  repeatPassword: string;
  phone: string;
  streetAddress: string;
  aptSuiteBuilding: string;
  city: string;
  state: number;
  zipCode: string;
  termsOfService: boolean;
  acknowledged: boolean;
};

export const accountValidationSchemaBase = {
  firstName: string().required("First name is required"),
  lastName: string().required("Last name is required"),
  county: string().required("County is required"),
  municipality: string().required("Municipality is required"),
  phone: string()
    .required("Phone is required")
    .matches(
      /^\+?(1\s?)?((\([0-9]{3}\))|[0-9]{3})[\s\\-]?[0-9]{3}[\s\\-]?[0-9]{4}$/,
      "Phone number is invalid"
    ),
  email: string()
    .email("Please enter a valid email")
    .required("Email is required"),
  streetAddress: string().required("Street address is required"),
  aptSuiteBuilding: string().defined().strict(true),
  city: string().required("City is required"),
  state: number().positive("State is required").integer().required("State is required"),
  zipCode: string()
    .required("Zip code is required")
    .matches(/^[0-9]+$/, "Must be only digits")
    .min(5, "Must be exactly 5 digits")
    .max(5, "Must be exactly 5 digits"),
};

const createAccountValidationSchema: ObjectSchema<CreateAccountFormValues> = object({
  ...accountValidationSchemaBase,
  password: string().required("Password is required"),
  repeatPassword: string()
    .oneOf([ref("password")], "Passwords must match")
    .required("Reenter password is required"),
  termsOfService: boolean().required().oneOf([true]),
  acknowledged: boolean().required().oneOf([true]),
})
  .required();

export function useCreateAccountForm() {
  return useForm<CreateAccountFormValues>({
    resolver: yupResolver(createAccountValidationSchema),
    /* comment out above resolver if form isn't submitting and uncomment this block to debug
    resolver: async (data, context, options) => {
      // you can debug your validation schema here
      console.log("formData", data)
      console.log(
        "validation result",
        await yupResolver(createAccountValidationSchema)(data, context, options)
      )
      return yupResolver(createAccountValidationSchema)(data, context, options)
    },*/
    reValidateMode: "onChange",
    mode: 'onChange',
    defaultValues: {
      firstName: '',
      lastName: '',
      county: '',
      municipality: '',
      email: '',
      password: '',
      repeatPassword: '',
      phone: '+1',
      streetAddress: '',
      aptSuiteBuilding: '',
      city: '',
      state: -1,
      zipCode: '',
      termsOfService: false,
      acknowledged: false,
    },
  });
}
